class ProductActions extends HTMLElement {
  constructor() {
    super();
    this.compareButton = this.querySelector(".boost-sd__compare-button");
    this.compareInput = this.querySelector('input[type="checkbox"]');

    if (this.compareButton && this.compareInput) {
      this.compareButton.addEventListener(
        "click",
        this.handleCompareClick.bind(this)
      );
      this.updateButtonText();
    }
  }

  handleCompareClick() {
    this.compareInput.checked = !this.compareInput.checked;
    this.updateButtonText();

    // Dispatch change event
    const event = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    this.compareInput.dispatchEvent(event);
  }

  updateButtonText() {
    if (this.compareButton) {
      this.compareButton.textContent = this.compareInput.checked
        ? "Remove from Compare"
        : "Add to Compare";
    }
  }
}

customElements.define("product-actions", ProductActions);
